import actionCreatorFactory from 'typescript-fsa';
import { CacheView } from '../../../services/betting';
import { ServerType } from '../../System/systemConfig';

const actionCreator = actionCreatorFactory();

export const CACHE_LOAD = 'CACHE_LOAD';
export const cacheLoad = actionCreator<ServerType>(CACHE_LOAD);

export const CACHE_SET = 'CACHE_SET';
export const cacheSet = actionCreator<{serverName: ServerType, caches: CacheView[]}>(CACHE_SET);

export const CACHE_CLEAR = 'CACHE_CLEAR';
export const cacheClear = actionCreator<{serverName: ServerType, cache: string}>(CACHE_CLEAR);

export const CACHE_CLEAR_ALL = 'CACHE_CLEAR_ALL';
export const cacheClearAll = actionCreator<ServerType>(CACHE_CLEAR_ALL);

export const CACHE_SET_AVAILABLE = 'CACHE_SET_AVAILABLE';
export const cacheSetAvailable = actionCreator<{serverName: ServerType, available: boolean}>(CACHE_SET_AVAILABLE);
